import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { ModalFrame, ModalFrameFooter, ModalFrameInner, ModalFrameMessage } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';

import type { Subcampaign } from 'types';

applyTranslations(require('./shipping-address-modal.i18n.json'));

type Props = {
  subcampaign: Subcampaign,
  onCloseModal: () => void
};

class ShippingAddressModal extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { subcampaign, onCloseModal } = this.props;
    const shippingAddress = subcampaign.shippingAddress || null;

    return (
      <ModalFrame
        title={__t('shipping_address_modal.title')}
      >
        <ModalFrameInner>
          {
            shippingAddress ?
              <div className="shipping-address-modal">
                <div className="shipping-address-modal__section">
                  <div className="shipping-address-modal__label">
                    {__t('shipping_address_modal.label_shipping_address')}
                  </div>
                  <div className="shipping-address-modal__details">
                    {
                      shippingAddress.recipient && (
                        <div>{shippingAddress.recipient}</div>
                      )
                    }
                    {
                      shippingAddress.address1 && (
                        <div>{shippingAddress.address1}</div>
                      )
                    }
                    {
                      shippingAddress.address2 && (
                        <div>{shippingAddress.address2}</div>
                      )
                    }
                    {
                      (shippingAddress.city || shippingAddress.zip) && (
                        <div>
                          {shippingAddress.zip}
                          &nbsp;
                          {shippingAddress.city}
                        </div>
                      )
                    }
                    {
                      shippingAddress.stateProvinceRegion && (
                        <div>{shippingAddress.stateProvinceRegion}</div>
                      )
                    }
                    {
                      shippingAddress.country && (
                        <div>{shippingAddress.country}</div>
                      )
                    }
                  </div>
                </div>
                {
                  shippingAddress.phone && (
                    <div className="shipping-address-modal__section">
                      <div className="shipping-address-modal__label">
                        {__t('shipping_address_modal.label_phone_number')}
                      </div>
                      <div className="shipping-address-modal__details">
                        <div>{shippingAddress.phone}</div>
                      </div>
                    </div>
                  )
                }
              </div> :
              <ModalFrameMessage
                message={__t('shipping_address_modal.message_no_shipping_address')}
              />
          }
        </ModalFrameInner>
        <ModalFrameFooter>
          <ActionButton onClick={onCloseModal}>
            {__t('shipping_address_modal.button_close')}
          </ActionButton>
        </ModalFrameFooter>
      </ModalFrame>
    );
  }
}

export default ShippingAddressModal;
